import { FormattedMessage } from 'react-intl';

function Cutoff({ label, isSelected }: { label: string; isSelected: boolean }) {
  return <option selected={isSelected}>{label}</option>;
}

type Props = Readonly<{
  cutoffs: string[] | null;
  selected: string | null;
  onSelect: (cutoff: string) => void;
}>;

export function Cutoffs({ cutoffs, selected, onSelect }: Props) {
  if (cutoffs === null || cutoffs.length === 0) {
    return null;
  }

  const onChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    onSelect(event.target.value);
  };

  return (
    <div className="d-flex flex-row align-items-center me-3">
      <label htmlFor="currency-cutoffs" className="text-secondary flex-shrink-0 me-4">
        <FormattedMessage id="form.CutOff" />
      </label>
      <select className="form-select flex-grow-1" id="currency-cutoffs" onChange={onChange}>
        {cutoffs?.map(c => (
          <Cutoff key={c} label={c} isSelected={c === selected} />
        ))}
      </select>
    </div>
  );
}
